import type { HubspotIntegrationConfiguration as HubspotIntegrationConfigurationV3 } from '@vy/integrations-types';
import type { HubspotIntegrationConfiguration } from '@vy/types';
import React from 'react';

type HubspotConfigurationProps = {
  configuration: HubspotIntegrationConfiguration | HubspotIntegrationConfigurationV3;
};

export const HubspotConfiguration: React.FC<HubspotConfigurationProps> = ({ configuration }) => {
  console.info(configuration);

  return <div className="h-[max(100%,100vh,fit)] min-h-fit bg-[#F6F9FA]">Hubspot Configuration</div>;
};
